// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__16EOk","inputWrap":"CustomTip_inputWrap__9IUyg"};